import React from 'react';
import {
  classes as newColorsBrandingClasses,
  st,
} from './newColorsBranding.st.css';
import { classes as madeforClasses } from './madefor.st.css';
import { classes as madeDisplayforClasses } from './madefordisplay.st.css';
import { WixDesignSystemProviderProps } from './WixDesignSystemProvider.types';
import { classes } from './WixDesignSystemProvider.st.css';
import { WixDesignSystemContext } from './context';
import { WixStyleReactEnvironmentContext } from '../WixStyleReactEnvironmentProvider/context';
import { WixStyleReactEnvironmentProvider } from '../WixStyleReactEnvironmentProvider';

const WixDesignSystemProvider: React.FC<WixDesignSystemProviderProps> = ({
  dataHook,
  className,
  // FIXME: MAJOR RELEASE: make this a block element (div), not an inline element (span) because of safari specific issue with focus.
  as = 'span',
  mobile = false,
  children,
  theme,
  features = {},
  locale,
  pageHeaderId,
  contextClassName = '',
  ...rest
}) => {
  const compactMode = features?.compactMode || false;
  const newBrandingClass = newColorsBrandingClasses.root;
  const environmentContext = React.useContext(WixStyleReactEnvironmentContext);

  return (
    <WixDesignSystemContext.Provider
      value={{ newBrandingClass, mobile, contextClassName }}
    >
      <WixStyleReactEnvironmentProvider
        locale={locale ?? environmentContext?.locale}
        pageHeaderId={pageHeaderId ?? environmentContext?.pageHeaderId}
      >
        {React.createElement(
          as,
          {
            ...rest,
            'data-hook': dataHook,
            className: st(
              className,
              newBrandingClass,
              madeDisplayforClasses.madefordisplay,
              madeforClasses.madefor,
              theme?.className,
              mobile && classes.mobile,
              compactMode && 'compactMode',
            ),
          },
          children,
        )}
      </WixStyleReactEnvironmentProvider>
    </WixDesignSystemContext.Provider>
  );
};

export { WixDesignSystemProvider };
